import { SVGProps } from 'react';

const Wallpaper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 17v4m-4 0h8m-7-4 6.1-6.1a2 2 0 0 1 2.81.01L22 15m0 0V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Wallpaper;
